import { URL_REPLACEMENT } from '$const';
import { get } from '~services/api/methods';
import { createChangelogItems } from '../validators/ChangelogItems';

export async function fetchChangelogItems(startIndex = 0, count = 20) {
  const requestUrl = `${URL_REPLACEMENT.BACKEND_URL}/api/ebm/changelog/items?startIndex=${startIndex}&count=${count}`;
  const response = await get(requestUrl);
  return createChangelogItems(response);
}
